import { render, staticRenderFns } from "./u-cell-group.vue?vue&type=template&id=c4aeef32&scoped=true&"
import script from "./u-cell-group.vue?vue&type=script&lang=js&"
export * from "./u-cell-group.vue?vue&type=script&lang=js&"
import style0 from "./u-cell-group.vue?vue&type=style&index=0&id=c4aeef32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aeef32",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-cell-group/u-cell-group.vue"
export default component.exports